import UserAdministrationForm from './UserAdministrationForm'

export default UserAdministrationForm
